module.exports = __webpack_public_path__ + "img/totalwing.46b73f7b.webp";